<template>
  <v-app-bar app dark class="d-block d-md-none mobile-nav-bar">
    <v-container fluid>
      <div class="d-flex justify-space-between align-center" style="width: 100%;">
        <v-toolbar-title class="white--text" @click="handleNavigation('home')" style="cursor: pointer;">
          <v-img
            src="../assets/logo.png"
            max-width="130"
            height="auto"
            class="mr-2"
          ></v-img>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small class="white--text mx-3" v-bind="attrs" v-on="on" elevation="0">
              <v-icon class="white--text">mdi-web</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-for="(item, index) in languageList"
              :key="index"
              @click="$emit('change-language', index)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn fab small class="white--text" v-on="on" elevation="0">
              <v-icon class="white--text">mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openM2Website">
              <v-list-item-title>{{ $t("m2_group") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleNavigation('solution')">
              <v-list-item-title>{{ $t("solution") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleNavigation('about')">
              <v-list-item-title>{{ $t("about") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleNavigation('cases')">
              <v-list-item-title>{{ $t("cases") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleNavigation('contact')">
              <v-list-item-title>{{ $t("contact") }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleNavigation('research')" :class="{ active: currentPage === 'research' }">
              <v-list-item-title>{{ $t("research") }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: 'MobileNavigation',
  props: {
    languageList: {
      type: Array,
      required: true
    },
    currentPage: {
      type: String,
      default: 'home'
    }
  },
  methods: {
    openM2Website() {
      window.open('https://m2.m4ore.com', '_blank');
    },
    handleNavigation(target) {
      if (target === 'research') {
        if (this.$route.path !== '/research') {
          this.$router.push('/research').catch(() => {});
        }
      } else if (target === 'home') {
        if (this.$route.path !== '/') {
          this.$router.push('/').catch(() => {});
        }
      } else {
        // For solution, about, cases, contact - scroll to section
        if (this.$route.path !== '/') {
          // 如果不在首頁，導航到首頁並帶上 scrollTo 參數
          const query = { ...this.$route.query, scrollTo: target };
          this.$router.push({ path: '/', query }).catch(() => {});
        } else {
          // 如果已經在首頁，發出滾動事件
          this.$emit('scroll-to-target', target);
        }
      }
    }
  }
}
</script>

<style>
/* 直向大螢幕時強制顯示手機版導航（不使用 scoped 以覆蓋 Vuetify 類） */
@media screen and (orientation: portrait) and (max-width: 1200px) {
  .mobile-nav-bar.d-md-none {
    display: flex !important;
  }
}

.mobile-nav-bar .v-toolbar__content {
  width: 100%;
  padding: 0 24px;
}

.mobile-nav-bar .v-toolbar__content > .container {
  max-width: 100% !important;
  padding: 0;
}
</style>